import * as React from "react";
import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { Button } from "../../../components/ui/Button";
import { usePasswordValidation } from "../lib/hooks/usePasswordValidation";
import { passwordPattern } from "../../ProfileContainer/lib/passwordPattern"


export const UpdatePasswordModal = (props) => {
  const { isOpen, updatePassword, dismissModal } = props;
  const initialValues = { password: "", confirmationPassword: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [isValid, setValidForm] = useState(false);
  const [password, setPassword] = useState({
    firstPassword: "",
    secondPassword: "",
  });
  const [lowerCase, match, specialChar, upperCase, validLength] =
    usePasswordValidation({
      firstPassword: password.firstPassword,
      secondPassword: password.secondPassword,
    });

  const setFirst = (event) => {
    setPassword({ ...password, firstPassword: event.target.value });
  };

  const setSecond = (event) => {
    setPassword({ ...password, secondPassword: event.target.value });
  };

  useEffect(() => {
    setValidForm(validLength && upperCase && lowerCase && specialChar);
  });

  return (
    <Modal
      isOpen={isOpen}
      wrapClassName="blacklight"
      modalClassName="blacklight-modal"
      size={"lg"}
    >
      <ModalBody style={{ padding: "24px" }}>
        <h4>Change Password</h4>
        <div className="row" style={{ padding: "5px", marginBottom: "5px" }}>
          <div
            className="input-field col-sm-12 col-md-5"
            style={{ padding: 0 }}
          >
            <input
              value={password.firstPassword}
              name="password"
              id="password"
              type="password"
              className={isValid ? "valid" : ""}
              placeholder="password"
              pattern={passwordPattern}
              onChange={setFirst}
              required
            />
            <label htmlFor="password" data-success="Valid" className="active">
              Password
            </label>
            <ul>
              <li>
                {validLength ? null : (
                  <div>
                    <span className="text-danger">
                      Invalid: Minimum 10 characters.
                    </span>
                  </div>
                )}
              </li>
              <li>
                {upperCase ? null : (
                  <span className="text-danger">
                    Invalid: At least one uppercase.
                  </span>
                )}
              </li>
              <li>
                {lowerCase ? null : (
                  <span className="text-danger">
                    Invalid: At least one lowercase.
                  </span>
                )}
              </li>
              <li>
                {specialChar ? null : (
                  <span className="text-danger">
                    Invalid: At least one special character (#?!@$%^&*-).
                  </span>
                )}
              </li>
            </ul>
          </div>
          <div className="input-field col-md-1" />
          <div
            className="input-field col-sm-12 col-md-5"
            style={{ padding: 0 }}
          >
            <input
              value={password.secondPassword}
              name="confirmationPassword"
              id="confirm_password"
              type="password"
              className={match ? "valid" : ""}
              placeholder="confirm password"
              onChange={setSecond}
              pattern={passwordPattern}
              required
            />
            <label
              htmlFor="confirm_password"
              data-success="Valid"
              className="active"
            >
              Confirm Password
            </label>
            <ul>
              <li>
                {match ? null : (
                  <span className="text-danger">
                    Invalid: Passwords do not match.
                  </span>
                )}
              </li>
            </ul>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="btn btn-white" onClick={() => dismissModal()}>
          Cancel
        </Button>
        <Button
          className="btn btn-action"
          onClick={() => {
            setFormValues(initialValues);
            updatePassword(password.firstPassword);
          }}
          disabled={!isValid || !match}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};
